/**
 *  <Desription of Service here>
 *
 * @export
 * @class TransitionManager
 */
export class TransitionManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', '$animate'];
  public transitionContainer
  public leftPanel
  public rightPanel
  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public $animate: any) {
    this.$log = $log.getInstance('TransitionManager', false);
    this.$log.debug('constructor');
    this.transitionContainer = angular.element(document.querySelector('transition-container'))
    this.leftPanel = angular.element(document.querySelector('.transition-container__panel--left'))
    this.rightPanel = angular.element(document.querySelector('.transition-container__panel--right'))
  }

  public close() {
    this.$log.debug('close')
    this.transitionContainer.addClass('active')
    this.$animate.addClass(this.rightPanel, 'closeRight')
    return this.$animate.addClass(this.leftPanel, 'closeLeft')
  }

  public open() {
    let _this = this;
    this.$log.debug('close')
    this.$animate.removeClass(this.leftPanel, 'closeLeft').then(() => {
      _this.transitionContainer.removeClass('active')
    })
    return this.$animate.removeClass(this.rightPanel, 'closeRight')
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/transition-manager/transition-manager.ts
 **/